<!--TODO: btr way to pass id to delete method without using selectedId property? refine code for popup on view--> 

<template>
  <v-container class="p-0">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <!--delete confirmation dialog-->
    <Dialog
      :title="'Are you sure you want to delete this item?'"
      :text="'This action is not reversible.'"
      :rejectButtonText="'No'"
      :acceptButtonText="'Yes'"
      :toggle="dialog"
      @reject="dialog = false"
      @accept="confirmDeleteItem"
    />

    <!--popup when user clicks on view-->
    <v-dialog v-model="videoPreview" max-width="340px" overlay-opacity="0">
      <v-card class="video">
        <video
          ref="previewVideo"
          :key="videoPreviewDetails.videoUrl"
          controls
          width="100%"
        >
          <source :src="videoPreviewDetails.videoUrl" type="video/mp4" />
        </video>
        <img
          @click="enableVideo"
          :src="videoPreviewDetails.imageUrl"
          :key="videoPreviewDetails.imageUrl"
        />
        <div class="video-desc">
          <div>
            <div>{{ videoPreviewDetails.title }}</div>
            <div>{{ videoPreviewDetails.duration }}</div>
          </div>
          <div>
            <v-icon size="12px" color="#9B9B9B;">arrow_forward_ios</v-icon>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" md="7" class="pt-0">
        <div class="header text-left">Manage Videos</div>
      </v-col>
      <v-col cols="12" md="5" class="action-buttons pt-0">
        <v-btn class="filter-btn" color="#FDBB30">Filter</v-btn>
        <v-btn class="create-btn" color="#00457C" @click="createVideo"
          >Create Video</v-btn
        >
      </v-col>
    </v-row>

    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pt-0">
        <!-- Table -->
        <TableComponent
          type="popup"
          v-bind:dynamicHeaders="dynamicHeaders"
          v-bind:dynamicWidths="dynamicWidths"
          v-bind:dynamicRowsDetail="dynamicRowsDetail"
          v-on:view-item="viewPopup"
          v-on:edit-item="editPopup"
          v-on:delete-item="deletePopup"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TableComponent from "./commons/TableComponent";
import Axios from "axios";
import Dialog from "./commons/Dialog";
import LoadingScreen from "./commons/LoadingScreen";

export default {
  components: {
    TableComponent,
    Dialog,
    LoadingScreen,
  },
  created() {
    Axios.get(process.env.VUE_APP_HOST_SERVER + "/api/videos/get_all")
      .then((res) => {
        console.log("Successfully retrieved all details");
        this.rawVideoPreviewDetails = res.data;
        this.dynamicRowsDetail = this.processFetchedData(res.data);
      })
      .catch((err) => console.log(err));
  },
  data() {
    return {
      loading: false,
      dynamicHeaders: [
        { text: "Title", value: "title" },
        { text: "Video URL", value: "videoUrl" },
        { text: "Sequence", value: "sequence" },
        { text: "Actions", value: "actions" },
      ],
      dynamicWidths: ["150px", "150px", "150px", "50px"],
      dynamicRowsDetail: [],
      dialog: false,
      selectedId: "",
      videoPreview: false,
      rawVideoPreviewDetails: [],
      videoPreviewDetails: {
        title: "",
        imageUrl: "",
        videoUrl: "",
        duration: null,
      },
      error: false,
      showVideo: false,
    };
  },

  watch: {
    videoPreview(val) {
      if (!val) {
        this.$refs.previewVideo.pause();
        this.$refs.previewVideo.currentTime = 0;
      }
    },
  },

  computed: {
    previewBg() {
      return "'" + this.newsEventsPreviewDetails.message.imageUrl + "'";
    },
  },

  methods: {
    processFetchedData(rawData) {
      return rawData.map(({ _id, title, videoUrl, sequence }) => {
        return {
          rowId: _id,
          title: title,
          videoUrl: videoUrl,
          sequence: sequence,
          action: { view: "show", edit: "show", delete: "show" },
        };
      });
    },
    viewPopup(id) {
      this.showVideo = false;
      this.videoPreviewDetails = this.rawVideoPreviewDetails.find(
        (item) => item._id === id
      );
      this.videoPreview = true;
    },

    enableVideo() {
      this.showVideo = true;
      this.$refs.previewVideo.play();
      this.$refs.previewVideo.requestFullscreen();
      //TODO: reset video once user exits full screen; currently video only resets when user closes the preview
    },

    editPopup(id) {
      this.$router
        .push({ name: "EditVideos", params: { itemId: id } })
        .catch(() => {});
    },

    deletePopup(id) {
      this.dialog = true;
      this.selectedId = id;
    },

    confirmDeleteItem() {
      this.loading = true;

      this.dialog = false;

      let id = this.selectedId;

      let imageUrl = this.rawVideoPreviewDetails.find((item) => item._id === id)
        .imageUrl;

      let videoUrl = this.rawVideoPreviewDetails.find((item) => item._id === id)
        .videoUrl;

      Axios.delete(
        process.env.VUE_APP_HOST_SERVER +
          "/api/videos/delete/" +
          this.selectedId
      ).then(() => {
        console.log("Deleted video from database.");
        Axios.delete(process.env.VUE_APP_HOST_SERVER + "/api/file/delete", {
          data: {
            s3Url: videoUrl,
          },
        })
          .then(() => {
            console.log("Deleted video from s3");
            Axios.delete(process.env.VUE_APP_HOST_SERVER + "/api/file/delete", {
              data: {
                s3Url: imageUrl,
              },
            }).then(() => {
              console.log("Deleted image from s3");

              let deleteIndex = this.dynamicRowsDetail.findIndex(
                (item) => item.rowId === id
              );

              this.dynamicRowsDetail.splice(deleteIndex, 1);

              this.selectedId = "";

              this.loading = false;

              this.error = false;
            });
          })
          .catch((err) => {
            console.log(err);
            this.error = true;
          });
      });
    },

    createVideo() {
      this.$router.push({ name: "AddVideos" }).catch(() => {});
    },

    newsEventsRedirect(url) {
      window.open(url);
    },
  },
};
</script>

<style>
.video.v-card {
  border-radius: 5px !important;
}

.video > img {
  border-radius: 5px;
  height: 170px;
  width: 100%;
}

.video > video {
  position: absolute;
  z-index: -1;
}

.video-desc {
  display: flex;
  padding: 16px 20px;
  align-items: center;
  justify-content: space-between;
}

.video-desc > div:first-child > div:first-child {
  font-size: 12px;
}

.video-desc > div:first-child > div:nth-child(2) {
  font-size: 11px;
  color: #9b9b9b;
}
</style>
